import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'retailers',
    loadChildren: () => import('./modules/retailers/retailers.module').then(m => m.RetailersModule)
  },
  {
    path: 'planograms',
    loadChildren: () => import('./modules/planograms/planograms.module').then(m => m.PlanogramsModule)
  },
  {
    path: 'orders',
    loadChildren: () => import('./modules/orders/orders.module').then(m => m.OrdersModule)
  },
  {
    path: 'settings',
    loadChildren: () => import('./modules/settings/settings.module').then(m => m.SettingsModule)
  },
  {
    path: 'viewers',
    loadChildren: () => import('./modules/viewers/viewers.module').then(m => m.ViewersModule)
  },
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full'
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
